import {
  createContext,
  useContext,
  useState,
  useRef,
  useCallback,
} from "react";
import axios from "axios";

const MarketSnapshotContext = createContext();

export const MarketSnapshotProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [marketSnapshot, setMarketSnapshot] = useState(null);
  const [marketLoading, setMarketLoading] = useState(false);
  const [marketError, setMarketError] = useState(null);
  const [dashboardMarketRows, setDashboardMarketRows] = useState([]);
  const [dashboardIndexData, setDashboardIndexData] = useState(null);
  const [dashboardMarketMap, setDashboardMarketMap] = useState({});
  const [dashboardLastUpdated, setDashboardLastUpdated] = useState(null);
  // const [dashboardTrendData, setDashboardTrendData] = useState({});
  const [dashboardTrendData, setDashboardTrendData] = useState([]);
  const [dashboardTrendLoading, setDashboardTrendLoading] = useState(false);
  const [dashboardTrendError, setDashboardTrendError] = useState(null);
  const [dashboardIndexTab, setDashboardIndexTab] = useState(null);
  const trendRequestIdRef = useRef(0);
  const [dashboardData, setDashboardData] = useState({});
  const [dashboardDataLoading, setDashboardDataLoading] = useState(false);
  const [dashboardDataError, setDashboardDataError] = useState(null);

  const [allIndexTabs, setAllIndexTabs] = useState();
  const [indexTabsLoading, setIndexTabsLoading] = useState(false);
  const [indexTabsError, setIndexTabsError] = useState(null);

  /* =========================
     INIT MARKET SNAPSHOT
     - add active symbol
     - fetch quote + intraday
     - calculate backend signals
     - save DB
     - return data to frontend
  ========================= */

  const [dashboardMarketData, setDashboardMarketData] = useState([]);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState(null);

  const [allCrossoverData, setAllCrossoverData] = useState(null);
  const [allCrossoverLoading, setAllCrossoverLoading] = useState(false);
  const [allCrossoverError, setAllCrossoverError] = useState(null);

  // const loadAllCrossover = useCallback(async (force = false) => {
  //   const todayIST = new Intl.DateTimeFormat("en-CA", {
  //     timeZone: "Asia/Kolkata",
  //   }).format(new Date());

  //   // Session-level dedupe
  //   if (!force && allCrossoverData?.date === todayIST) {
  //     console.log("Session cache hit for all-crossover");
  //     return;
  //   }

  //   try {
  //     setAllCrossoverLoading(true);
  //     setAllCrossoverError(null);
  //     const url = force
  //       ? "/api/dashboard/all-crossover?refresh=1"
  //       : "/api/dashboard/all-crossover";
  //     const res = await axios.get(url); // adjust to your axios instance
  //     setAllCrossoverData(res.data);
  //   } catch (err) {
  //     console.error("loadAllCrossover error:", err);
  //     setAllCrossoverError(err.response?.data?.message || err.message);
  //   } finally {
  //     setAllCrossoverLoading(false);
  //   }
  // }, [allCrossoverData]);

  const loadAllCrossover = async (force = false) => {
    try {
      const todayIST = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Asia/Kolkata",
      }).format(new Date());

      // Session-level dedupe — skip if already loaded today
      if (!force && allCrossoverData?.date === todayIST) {
        console.log("⚡ Session cache hit for all-crossover");
        return allCrossoverData;
      }

      setAllCrossoverLoading(true);
      setAllCrossoverError(null);

      const res = await axios.get(`${BASE_URL}/api/dashboard/all-crossover`, {
        params: force ? { refresh: 1 } : {},
      });

      console.log("All-crossover response:", res.data);
      setAllCrossoverData(res.data);

      return res.data;
    } catch (err) {
      console.error(
        "All-crossover load error:",
        err?.response?.data || err.message,
      );
      setAllCrossoverError(
        err?.response?.data?.message || "Failed to load crossover data",
      );
      return null;
    } finally {
      setAllCrossoverLoading(false);
    }
  };

  //previous workinf code
  // const loadDashboardIndexMarket = async ({ indexName, stocks }) => {
  //   try {
  //     if (!indexName || !stocks?.length) return {};

  //     setDashboardLoading(true);
  //     setDashboardError(null);

  //     const res = await axios.post(`${BASE_URL}/api/dashboard/index-market`, {
  //       indexName,
  //       stocks,
  //     });

  //     const rows = res?.data?.data || [];

  //     const marketMap = {};

  //     rows.forEach((row) => {
  //       if (row?.symbol) {
  //         marketMap[row.symbol.trim().toUpperCase()] = row;
  //       }
  //     });

  //     // existing state
  //     setDashboardMarketData(marketMap);

  //     // new states
  //     setDashboardMarketRows(rows);
  //     setDashboardMarketMap(marketMap);
  //     setDashboardLastUpdated(new Date().toISOString());

  //     return marketMap;
  //   } catch (err) {
  //     console.error(
  //       "Dashboard market load error:",
  //       err?.response?.data || err.message,
  //     );

  //     setDashboardError(
  //       err?.response?.data?.message || "Failed to load dashboard market data",
  //     );

  //     return {};
  //   } finally {
  //     setDashboardLoading(false);
  //   }
  // };

  //all tabs

  const getAllIndexTabs = async () => {
    try {
      setIndexTabsLoading(true);
      setIndexTabsError(null);
      const res = await axios.get(`${BASE_URL}/api/dashboard/all-indices`);
      setAllIndexTabs(res.data);
      console.log("All index tabs data", res);
    } catch (err) {
      setIndexTabsError(err);
    } finally {
      setIndexTabsLoading(false);
    }
  };
  const loadDashboardIndexMarket = async ({ indexName }) => {
    try {
      if (!indexName) return {};

      setDashboardLoading(true);
      setDashboardError(null);

      const res = await axios.post(`${BASE_URL}/api/dashboard/index-market`, {
        indexName,
      });

      const rows = res.data.data || [];
      setDashboardIndexTab(res.data.indexTabs);

      setDashboardIndexData(res.data.indexData || null);
      console.log("resdata from index", res.data);

      console.log("Rows from index", rows);
      const map = {};
      rows.forEach((row) => {
        map[row.symbol] = row;
      });

      setDashboardMarketData(map);

      return map;
    } catch (err) {
      console.error(
        "Dashboard market load error:",
        err?.response?.data || err.message,
      );

      setDashboardError(
        err?.response?.data?.message || "Failed to load dashboard market data",
      );

      return {};
    } finally {
      setDashboardLoading(false);
    }
  };


  const getDashboardData = async ({ indexName }) => {
    try {
      if (!indexName) return {};

      setDashboardDataLoading(true);
      setDashboardDataError(null);
      setDashboardData(null);

      const res = await axios.post(
        `${BASE_URL}/api/dashboard/index-market-data`,
        {
          indexName,
        },
      );

      const rows = res.data;
      // setDashboardIndexTab(res.data.indexTabs);
      setDashboardData(rows);
      // setDashboardIndexData(res.data.indexData || null);
      console.log("resdata from index", res.data);

      console.log("Rows from index", rows);
    } catch (err) {
      console.error(
        "Dashboard market load error:",
        err?.response?.data || err.message,
      );

      setDashboardDataError(
        err?.response?.data?.message || "Failed to load dashboard market data",
      );
      setDashboardData(null);

      return {};
    } finally {
      setDashboardDataLoading(false);
    }
  };

  const initializeMarketSnapshot = async ({ symbol, securityId }) => {
    if (!symbol || !securityId) return null;

    try {
      setMarketLoading(true);
      setMarketError(null);

      const res = await axios.post(`${BASE_URL}/api/market-snapshot/init`, {
        symbol,
        securityId,
      });

      setMarketSnapshot(res.data.data);

      return res.data.data;
    } catch (error) {
      console.error(
        "Initialize market snapshot error:",
        error.response?.data || error.message,
      );

      setMarketError(
        error.response?.data?.message || "Failed to initialize market snapshot",
      );

      return null;
    } finally {
      setMarketLoading(false);
    }
  };
  const resetDashboardMarketData = () => {
    setDashboardMarketData({});
  };

  const addActiveSymbol = async ({ symbol, securityId }) => {
    if (!symbol || !securityId) return null;

    try {
      const res = await axios.post(`${BASE_URL}/api/active-symbol`, {
        symbol,
        securityId,
      });

      return res.data;
    } catch (error) {
      console.error(
        "Add active symbol error:",
        error.response?.data || error.message,
      );

      return null;
    }
  };

  /* =========================
     FETCH FROM DB ONLY
  ========================= */

  const getMarketSnapshot = async (symbol) => {
    if (!symbol) return null;

    try {
      setMarketLoading(true);
      setMarketError(null);

      const res = await axios.get(`${BASE_URL}/api/market-snapshot/${symbol}`);

      setMarketSnapshot(res.data.data);

      return res.data.data;
    } catch (error) {
      console.error(
        "Market snapshot error:",
        error.response?.data || error.message,
      );

      setMarketError(
        error.response?.data?.message || "Failed to fetch market snapshot",
      );

      return null;
    } finally {
      setMarketLoading(false);
    }
  };

  const getDashboardStockSnapshot = (symbol) => {
    if (!symbol) return null;

    return dashboardMarketMap[symbol.trim().toUpperCase()] || null;
  };

  const getISTDateKey = () => {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());
  };

  const normalizeIndexName = (indexName) => {
    return indexName?.trim().toUpperCase();
  };

  const createTrendMap = (rows = []) => {
    const map = {};

    rows.forEach((row) => {
      const symbol = row?.symbol?.trim().toUpperCase();

      if (symbol) {
        map[symbol] = row;
      }
    });

    return map;
  };
  //previously code
  const loadDashboardIndexTrend = async ({ indexName }) => {
    try {
      if (!indexName) return {};
      setDashboardTrendLoading(true);
      setDashboardTrendError(null);

      const res = await axios.post(`${BASE_URL}/api/dashboard-index-trend`, {
        indexName,
      });

      console.log("res data from index trend", res);

      const rows = res.data.dashboardDataError || [];
      const map = {};
      rows.forEach((row) => {
        map[row.symbol] = row;
      });

      setDashboardTrendData(res.data.data);
      return map;
    } catch (err) {
      setDashboardTrendError(
        err?.response?.data?.message || "Failed to load trend data",
      );
      return {};
    } finally {
      setDashboardTrendLoading(false);
    }
  };
  // const loadDashboardIndexTrend = async ({
  //   indexName,
  //   forceRefresh = false,
  // }) => {
  //   if (!indexName) return {};

  //   const normalizedIndexName = normalizeIndexName(indexName);
  //   const todayIST = getISTDateKey();

  //   const cacheKey = `dashboard-index-trend:${normalizedIndexName}:${todayIST}`;

  //   try {
  //     setDashboardTrendError(null);

  //     /*
  //      * Use today's frontend cache first.
  //      * This avoids another backend request when:
  //      * - returning to the page
  //      * - changing back to an already loaded index
  //      * - refreshing the browser
  //      */
  //     if (!forceRefresh) {
  //       const cachedValue = localStorage.getItem(cacheKey);

  //       if (cachedValue) {
  //         try {
  //           const cached = JSON.parse(cachedValue);
  //           const cachedRows = Array.isArray(cached?.data) ? cached.data : [];

  //           console.log(`⚡ Frontend trend cache hit: ${normalizedIndexName}`);

  //           setDashboardTrendData(cachedRows);

  //           return createTrendMap(cachedRows);
  //         } catch (cacheError) {
  //           console.error("Invalid trend cache:", cacheError);

  //           // Remove corrupted cache
  //           localStorage.removeItem(cacheKey);
  //         }
  //       }
  //     }

  //     /*
  //      * Show loading only when backend request is actually required.
  //      */
  //     setDashboardTrendLoading(true);

  //     const res = await axios.post(`${BASE_URL}/api/dashboard-index-trend`, {
  //       indexName: normalizedIndexName,
  //     });

  //     console.log("Response data from index trend:", res.data);

  //     // Correct response property
  //     const rows = Array.isArray(res?.data?.data) ? res.data.data : [];

  //     const map = createTrendMap(rows);

  //     setDashboardTrendData(rows);

  //     /*
  //      * Save only the daily technical data.
  //      * Do not save WebSocket prices here.
  //      */
  //     localStorage.setItem(
  //       cacheKey,
  //       JSON.stringify({
  //         indexName: normalizedIndexName,
  //         marketDate: todayIST,
  //         cachedAt: Date.now(),
  //         data: rows,
  //       }),
  //     );

  //     return map;
  //   } catch (err) {
  //     console.error(
  //       "Dashboard trend load error:",
  //       err?.response?.data || err.message,
  //     );

  //     setDashboardTrendError(
  //       err?.response?.data?.message || "Failed to load trend data",
  //     );

  //     return {};
  //   } finally {
  //     setDashboardTrendLoading(false);
  //   }
  // };
  // const loadDashboardIndexTrend = async ({
  //   indexName,
  //   forceRefresh = false,
  // }) => {
  //   if (!indexName) return {};

  //   const normalizedIndexName = normalizeIndexName(indexName);
  //   const todayIST = getISTDateKey();

  //   const cacheKey = `dashboard-index-trend:${normalizedIndexName}:${todayIST}`;

  //   // Every new request gets a unique ID
  //   const requestId = ++trendRequestIdRef.current;

  //   const readCachedRows = () => {
  //     try {
  //       const cachedValue = localStorage.getItem(cacheKey);

  //       if (!cachedValue) return [];

  //       const cached = JSON.parse(cachedValue);

  //       return Array.isArray(cached?.data) ? cached.data : [];
  //     } catch (error) {
  //       console.error("Trend cache read error:", error);
  //       localStorage.removeItem(cacheKey);
  //       return [];
  //     }
  //   };

  //   try {
  //     /*
  //      * Do not allow an old error to remain visible.
  //      */
  //     setDashboardTrendError(null);

  //     /*
  //      * Use today's local cache unless this is a forced refresh.
  //      */
  //     if (!forceRefresh) {
  //       const cachedRows = readCachedRows();

  //       if (cachedRows.length > 0) {
  //         console.log(`⚡ Frontend trend cache hit: ${normalizedIndexName}`);

  //         // Only update when this is still the latest request
  //         if (requestId === trendRequestIdRef.current) {
  //           setDashboardTrendData(cachedRows);
  //           setDashboardTrendLoading(false);
  //         }

  //         return createTrendMap(cachedRows);
  //       }
  //     }

  //     setDashboardTrendLoading(true);

  //     const res = await axios.post(`${BASE_URL}/api/dashboard-index-trend`, {
  //       indexName: normalizedIndexName,
  //     });

  //     console.log("Trend API response:", res.data);

  //     if (res?.data?.success === false) {
  //       throw new Error(
  //         res?.data?.message || "Trend API returned success false",
  //       );
  //     }

  //     const rows = Array.isArray(res?.data?.data) ? res.data.data : [];

  //     if (rows.length === 0) {
  //       throw new Error(`No trend data received for ${normalizedIndexName}`);
  //     }

  //     const map = createTrendMap(rows);

  //     /*
  //      * Ignore this response if another index request started later.
  //      */
  //     if (requestId !== trendRequestIdRef.current) {
  //       console.log(`Ignoring old trend response for ${normalizedIndexName}`);

  //       return map;
  //     }

  //     setDashboardTrendData(rows);
  //     setDashboardTrendError(null);

  //     localStorage.setItem(
  //       cacheKey,
  //       JSON.stringify({
  //         indexName: normalizedIndexName,
  //         marketDate: todayIST,
  //         cachedAt: Date.now(),
  //         data: rows,
  //       }),
  //     );

  //     return map;
  //   } catch (err) {
  //     console.error("Dashboard trend request failed:", {
  //       indexName: normalizedIndexName,
  //       url: err?.config?.url,
  //       status: err?.response?.status,
  //       response: err?.response?.data,
  //       message: err?.message,
  //     });

  //     /*
  //      * Ignore an error belonging to an older request.
  //      */
  //     if (requestId !== trendRequestIdRef.current) {
  //       console.log(`Ignoring old trend error for ${normalizedIndexName}`);

  //       return {};
  //     }

  //     /*
  //      * Use existing cache if refresh/API request failed.
  //      */
  //     const cachedRows = readCachedRows();

  //     if (cachedRows.length > 0) {
  //       console.warn(
  //         `Using cached trend data after API failure: ${normalizedIndexName}`,
  //       );

  //       setDashboardTrendData(cachedRows);
  //       setDashboardTrendError(null);

  //       return createTrendMap(cachedRows);
  //     }

  //     setDashboardTrendError(
  //       err?.response?.data?.message ||
  //         err?.message ||
  //         "Failed to load trend data",
  //     );

  //     return {};
  //   } finally {
  //     /*
  //      * An older request must not stop loading for a newer request.
  //      */
  //     if (requestId === trendRequestIdRef.current) {
  //       setDashboardTrendLoading(false);
  //     }
  //   }
  // };
  const resetDashboardTrendData = () => setDashboardTrendData({});

  const resetMarketSnapshot = () => {
    setMarketSnapshot(null);
    setMarketError(null);
    setMarketLoading(false);
  };

  return (
    <MarketSnapshotContext.Provider
      value={{
        marketSnapshot,
        marketLoading,
        marketError,

        initializeMarketSnapshot,
        addActiveSymbol,
        getMarketSnapshot,
        resetMarketSnapshot,
        dashboardMarketData,
        dashboardLoading,
        dashboardError,
        loadDashboardIndexMarket,
        resetDashboardMarketData,
        setDashboardIndexData,
        dashboardIndexData,
        dashboardTrendData,
        dashboardTrendLoading,
        dashboardTrendError,
        loadDashboardIndexTrend,
        resetDashboardTrendData,
        dashboardIndexTab,
        getDashboardData,
        dashboardData,
        dashboardDataLoading,
        dashboardDataError,
        getAllIndexTabs,
        allIndexTabs,
        indexTabsError,
        indexTabsLoading,
        loadAllCrossover,
        allCrossoverLoading,
        allCrossoverData,
        allCrossoverError,
      }}
    >
      {children}
    </MarketSnapshotContext.Provider>
  );
};

export const useMarketSnapshot = () => {
  return useContext(MarketSnapshotContext);
};
